import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VehicleFilterCacheService {
  private readonly KEY = 'scheduler:selectedVehicleIds';

  // was anything stored?
  has(): boolean {
    return localStorage.getItem(this.KEY) !== null;
  }

  get(): number[] {
    try {
      return JSON.parse(localStorage.getItem(this.KEY) ?? '[]') as number[];
    } catch {
      return [];
    }
  }

  set(ids: number[]): void {
    localStorage.setItem(this.KEY, JSON.stringify(ids));
  }

  clear(): void {
    localStorage.removeItem(this.KEY);
  }
}
